import { Autocomplete, TextField } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { userFioToString } from '../../helpers/userFioToString'
import RootStore from '../../store/RootStore'
import { User } from '../../types/models/User'

const margin = 'dense'
const variant = 'standard'
type Props = {
  filters?: {
    role?: string
  }
  noFilters?: boolean
  notApproved?: boolean
}

const UserSelect = observer((props: Props) => {
  const { filters, noFilters, notApproved } = props
  const users = RootStore.userAction.users
  const locationId = RootStore.settingsStore.locationId

  const user = RootStore.settingsStore.user

  const [defUser, setDefUser] = React.useState(user)

  React.useEffect(() => {
    if (!users) {
      if (locationId) {
        RootStore.userAction.getCurrentUsers(locationId)
      } else RootStore.userAction.getUsers()
    }
  }, [locationId, users])

  const hundleChange = (user?: User | null) => {
    RootStore.settingsStore.setUser(user ? user : undefined)
  }

  if (RootStore.authStore.isAuth && !noFilters) return <></>

  const filteredUsers = users?.filter((user) => {
    if (notApproved) {
      return !user.approved
    }

    if (process.env.REACT_APP_USER_KEYS_ONLY  === 'true') return false

    if (noFilters) return true

    if (filters?.role === '') {
      return user.roles?.length
    } else if (filters?.role) {
      const roles = user.roles?.map((role) => role.value)
      return roles?.includes(filters.role)
    } else {
      return true
    }
  })

  return (
    <div style={{ width: '100%' }}>
      {filteredUsers ? (
        <Autocomplete
          options={filteredUsers}
          onChange={(event: any, newValue) => {
            hundleChange(newValue)
          }}
          defaultValue={defUser}
          inputValue={user ? userFioToString(user) : ''}
          getOptionLabel={ (option) => userFioToString(option) }
          isOptionEqualToValue={(option, value) => option.id === value.id}
          noOptionsText={'Поднесите ключ или войдите в систему'}
          renderInput={(params) => (
            <TextField
              {...params}
              value={user ? userFioToString(user) : ''}
              label="Пользователь"
              variant={variant}
              margin={margin}
            />
          )}
        />
      ) : null}
    </div>
  )
})

export default UserSelect
